import React, { useContext } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Form, Input, Space } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_TIME_ON_PAGE_SECONDS } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const TimeOnPageConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    return !loading ? (
        <Space.Compact size="medium">
            <Input
                key={selectedPromptIdx}
                placeholder="0"
                className="vc-time-on-page"
                type="number"
                min={0}
                defaultValue={value?.timeOnPageSeconds ?? DEFAULT_TIME_ON_PAGE_SECONDS}
                onChange={(ev) => {
                    const nextCondition = PromptVisitorConditions.from({
                        timeOnPageSeconds: ev.target.value as any,
                    })

                    try {
                        nextCondition.timeOnPageSeconds = parseInt(ev.target.value, 10)
                    } catch {}

                    onChange(nextCondition)
                }}
                style={{ width: 100 }}
            />
            <Space.Addon>
                <span>seconds spent on page</span>
            </Space.Addon>
        </Space.Compact>
    ) : null
}
